import $ from 'jquery';
import { isSignedIn } from 'Util/Auth';

// COMMENT OUT BEFORE COMMIT
export function findbarScript() {
    // script.src = 'https://dev.findbar.io/js/hondoscenter.com/findbar.js'
    $(document).ready(function () {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://app.findbar.io/js/hondoscenter.com/findbar.js'
        script.async = true;
        document.head.appendChild(script);
    });
}

export function findbarEnglishScript() {
    // script.src = 'https://dev.findbar.io/js/hondoscenter.com/findbar.js?index=yykfma'
    $(document).ready(function () {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://app.findbar.io/js/hondoscenter.com/findbar.js?index=eyokao'
        script.async = true;
        document.head.appendChild(script);
    });
}

export function fbrAddToWhishlist(
    showPopup,
    removeProductFromWishlist,
    productsInWishlist
) {
    window.addEventListener('ProductWishlist', function (e) {
        // console.log("Toggle wishlist Event", e.detail);
        if (!isSignedIn()) {
            return showPopup(
                "PRODUCTLIST_POPUP",
                { ...e.detail.extra }
            )
        }
        if (e.detail.isWishlistItem) {
            const { wishlist: { id: item_id } } = Object.values(productsInWishlist).find(
                ({ wishlist: { sku } }) => sku === e.detail.extra.sku
            );
            return removeProductFromWishlist({ item_id, sku: e.detail.extra.sku });
        }
        if (isSignedIn() && e.detail.isSimple) {
            return showPopup(
                "WISHLIST_POPUP",
                { ...e.detail.extra }
            )
        }
        else {
            return showPopup(
                "PRODUCTLIST_POPUP",
                { ...e.detail.extra }
            )
        }
    })
}

export function fbrAddToCart(showPopup) {
    window.addEventListener('AddToCart', function (e) {
        // console.log("Add to cart Event", e.detail);
        return showPopup(
            "PRODUCTLIST_POPUP",
            { ...e.detail }
        )
    })
}
